module.exports = __webpack_public_path__ + "img/bj.58f4d18.png";